
<template>
  <form class="flex flex-col gap-2" :class="isSubmitted && 'pointer-events-none'">
    <SubscribeMilkFormButton
      v-for="(label, index) in labels"
      :key="index"
      :label="label"
      :class="selectedButton === index && 'bg-green-100 border border-green-400'"
      @click="(e) => handleClick(index, e)"
    />
    <div v-if="isSubmitted" class="flex-center flex-col mt-2">
      <p>Thanks for your help.</p>
      <p>Our Flavor Team is reviewing now!</p>
    </div>
  </form>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SubscribeMilkFormButton from './subscribe-milk-form-button.vue'

const labels = [
  'Dairy Milk',
  'Sweetened Almond Milk',
  'Unsweetened Almond Milk',
  'Oat Milk',
  'Soy Milk',
  'Other'
]

const isSubmitted = ref(false)
const selectedButton = ref<number | null>(null)

const handleClick = (index: number, event: Event) => {
  event.preventDefault()
  isSubmitted.value = true
  selectedButton.value = index
}
</script>
